import React from 'react';
import { IconProps } from '../../../DefaultIcon';

export function AdmissionsIcon({ className }: IconProps) {
  return (
    <svg
      width="73"
      height="71"
      viewBox="0 0 73 71"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_1147_2763)">
        <path
          d="M68.8726 66.5693C67.3222 54.8901 59.8104 45.0822 49.438 40.1782C45.158 43.0389 40.0045 44.7165 34.458 44.7165C28.9115 44.7165 23.7581 43.0389 19.4781 40.1782C9.10565 45.0822 1.57199 54.8901 0.0434272 66.5693C-0.262286 68.9353 1.61567 71.0216 4.03954 71.0216H64.8983C67.3222 71.0216 69.2002 68.9353 68.8945 66.5693H68.8726Z"
          fill="#00416B"
        />
        <path
          d="M53.1506 18.4114C53.1506 28.585 44.7872 36.8228 34.4584 36.8228C24.1297 36.8228 15.7881 28.585 15.7881 18.4114C15.7881 8.23781 24.1297 0 34.4584 0C44.7872 0 53.1506 8.23781 53.1506 18.4114Z"
          fill="#00416B"
        />
        <path
          d="M70.1614 54.5889H62.06V51.2336V46.5232C62.06 44.9746 60.7716 43.7056 59.1994 43.7056C57.6271 43.7056 56.3388 44.9746 56.3388 46.5232V54.6104H48.1282C46.5559 54.6104 45.2676 55.8795 45.2676 57.4281C45.2676 58.9767 46.5559 60.2457 48.1282 60.2457H51.3163H54.8102H56.3388V68.2254C56.3388 69.774 57.6271 71.043 59.1994 71.043C60.7716 71.043 62.06 69.774 62.06 68.2254V65.1927V60.2457H65.4665H70.1614C71.7336 60.2457 73.022 58.9767 73.022 57.4281C73.022 55.8795 71.7336 54.6104 70.1614 54.6104V54.5889Z"
          fill="#00C4B3"
        />
      </g>
      <defs>
        <clipPath id="clip0_1147_2763">
          <rect width="73" height="71" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
